
export default function TestError() {
  const error = null

  null.fakeFunction

  return(
    <div></div>
  )
}